<mat-toolbar-row class="white" fxLayoutAlign="flex-end center">
    <mat-icon class="mr-24" (click)="goToUpdateMyProfile()" *ngIf="myProfile.email === user.email">edit</mat-icon>
    <mat-icon class="close-dialog pointer" (click)="dialogRef.close()">close</mat-icon>
</mat-toolbar-row>

<div mat-dialog-content fxLayout="column" fxLayoutAlign="start">
    <div class="dialog-content-container" *ngIf="user">
        <div class="user-header" fxLayout="column" fxLayoutAlign="center center">
            <img *ngIf="user.avatar.src; else initials" [alt]="user.name" [src]="user.avatar.src" class="profile avatar user" />
            <ng-template #initials>
                <div fxLayoutAlign="center center" class="avatar-initials avatar slide-img profile avatar">{{ user.fullName | initials }}</div>
            </ng-template>
        </div>

        <div class="user-header-info pt-24 pb-20" fxLayout="column" fxLayoutAlign="center center">
            <h2 class="pl-16 mb-16">{{ user.fullName }}</h2>

            <div class="mb-16" fxLayout="row wrap" fxLayoutAlign="start center" *ngIf="user.socialNetworks?.length">
                <a class="text-truncate" *ngFor="let network of user.socialNetworks" href="{{ network.value }}" target="_blank">
                    <img class="social-icon" [alt]="network.type" [src]="network.imageUrl" />
                </a>
            </div>

            <app-flat-button
                [label]="'GENERAL.BUTTON.START_CHAT'"
                (onClick)="onStartConversation()"
                *ngIf="isChatFeatureActive && myProfile.email !== user.email"
            ></app-flat-button>
        </div>

        <div class="user-info-container px-24">
            <ng-container *ngFor="let item of user.attributes">
                <div class="info-field pb-16">
                    <h6 class="key mt-0">{{ item.attribute.translationKey | translate }}:</h6>
                    <p class="value my-0" [matTooltip]="(item.attribute | getUserExtendedAttributeValue: user.attributes) || ''" matTooltipPosition="above">
                        {{ (item.attribute | getUserExtendedAttributeValue: user.attributes) || '-' }}
                    </p>
                </div>
            </ng-container>

            <div *ngIf="user.socialMedia && user.socialMedia.length">
                <mat-divider class="mb-16"></mat-divider>

                <div class="info-field">
                    <span>{{ 'COMMUNITY.PROPERTY.SOCIAL' | translate }}</span>
                    <mat-list role="list">
                        <mat-list-item role="listitem" *ngFor="let network of user.socialMedia">
                            <img class="avatar" [alt]="network.type" [src]="network.imageUrl" />
                            <span>{{ network.type }}</span>
                        </mat-list-item>
                    </mat-list>
                </div>
            </div>
        </div>
    </div>
</div>
